import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateParkingServicePaymentMethods } from '../../api/parking-service.ts';
import { UpdateParkingServicePaymentMethodsRequest } from '../../api/requests/parking-service-request.ts';

export default function useUpdateParkingServicePaymentMethods(): UseMutationResult<
  Awaited<ReturnType<typeof updateParkingServicePaymentMethods>>,
  Error,
  UpdateParkingServicePaymentMethodsRequest
> {
  return useMutation({
    mutationFn: updateParkingServicePaymentMethods,
  });
}
